export default __webpack_public_path__ + "static/media/button-Rotate-On.956683c2.png";